import PropTypes from 'prop-types'

export default PropTypes.shape({
  counties_by_state: PropTypes.object.isRequired,
  national: PropTypes.bool,
  canada: PropTypes.bool
})
